<form (keydown.enter)="$event.preventDefault()" [formGroup]="basicForm">
  <div class="d-flex flex-column">
    <div class="l2-title">
      Basic
    </div>
    <div class="item-row mb-8px">
      <div class="item-label">Ticket#</div>
      <div class="item-value">
        <span *ngIf="isDetail" [innerHTML]="ticket.ticketInfo?.ticketNo | ticketNo"></span>
      </div>
      <div *ngIf="[companies.Sea].includes(company)" class="item-label">Customer Type</div>
      <div *ngIf="[companies.Sea].includes(company)" class="item-value">
        <ng-select (change)="customerTypeChange($event.code)"
                   [clearable]="false"
                   [items]="customerTypeOptions"
                   bindLabel="name"
                   bindValue="code"
                   class="form-control"
                   formControlName="customerType"
                   placeholder="Select">
        </ng-select>
      </div>
    </div>

    <div *ngIf="[companies.Sea].includes(company)" class="item-row mb-8px">
      <div class="item-label">Service Type</div>
      <div class="item-value">
        <ng-select (change)="serviceTypeChange($event.code)"
                   [clearable]="false"
                   [items]="serviceTypeOptions"
                   bindLabel="name"
                   bindValue="code"
                   class="form-control"
                   formControlName="serviceType"
                   placeholder="Select">
        </ng-select>
      </div>
      <div class="item-label">Detail Type</div>
      <div class="item-value-badge">
        <dp-badge [color]="color.detail" [size]="'wd-fit'" [text]="basic?.detailType"></dp-badge>
        <dp-badge-name [code]="basic?.detailType" [cssClass]="'badge-text ml-8px'"
                       [options]="detailTypes"></dp-badge-name>
      </div>
    </div>
    <div *ngIf="showServiceTypeRestriction" class="item-row mb-8px">
      <div class="text-service-type-description">{{ this.serviceTypeRestriction }}</div>
    </div>
    <div *ngIf="basic?.showInputField || basic?.showFileUpload || basic?.showDisplayUnitRepairType"
         class="d-flex flex-column">
      <div *ngIf="basic?.showDisplayUnitRepairType" class="item-row mb-8px">
        <div class="item-label">Repair Type for DM</div>
        <div class="item-w-100">
          <ng-select (change)="displayUnitRepairTypeChange($event.code)"
                     [clearable]="false"
                     [items]="displayUnitRepairTypeOptions"
                     bindLabel="name"
                     bindValue="code"
                     class="form-control"
                     formControlName="displayUnitRepairType"
                     placeholder="Select">
          </ng-select>

        </div>
      </div>
      <div *ngIf="basic?.showInputField || basic?.showDisplayUnitRepairType" class="item-row mb-8px">
        <div class="item-label">Detail Description</div>
        <div class="item-w-100">
          <input
            class="form-control"
            formControlName="detailDescription"
            type="text"
          />
        </div>
      </div>
      <!--<ng-container *ngIf="attachFiles.length;">
        <ng-container *ngFor="let attachFile of attachFiles">
          <div *ngIf="basic?.showFileUpload" class="item-row mb-16px">
            <ng-container *ngIf="!isDetail else isDetailTemp">
              <div class="item-label">Attach File</div>
              <div *ngIf="detailFile" class="item-w-100 d-flex">
                <span (click)="selectFile(true, attachFile)" class="receipts-text btn-cursor">{{attachFile.filename}}</span>
                <font-awesome (click)="fileDelete(attachFile)" [cssClass]="'ml-4px'" [icon]="'fa-regular fa-xmark'"
                              role="button"></font-awesome>
              </div>
            </ng-container>
            <ng-template #isDetailTemp>
              <div class="item-label">Attach File</div>
              <div *ngIf="attachFile" class="item-w-100 d-flex">
                <span (click)="selectFile(false, attachFile)" class="receipts-text btn-cursor">{{attachFile.filename}}</span>
              </div>
              <div *ngIf="!attachFile" class="item-value d-flex">
                <div (click)="imgFileInput.click()" class="item-receipts btn-cursor">
                  <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
                  <input #imgFileInput (change)="fileSelected($event)" hidden type="file"/>
                  <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>-->
      <!--<div *ngIf="basic?.showFileUpload && !isDetail" class="item-row mb-16px">
        <div class="item-label">Attach File New</div>
        <div class="item-value d-flex">
          <div (click)="imgFileInput.click()" class="item-receipts btn-cursor">
            <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
            <input #imgFileInput (change)="fileSelected($event)" hidden type="file"/>
            <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
          </div>
        </div>
      </div>-->

      <ng-container *ngIf="attachFiles.length;">
        <ng-container *ngFor="let attachFile of attachFiles; index as i">
          <div *ngIf="basic?.showFileUpload" class="item-row mb-16px">
            <ng-container *ngIf="!isDetail else isDetailTemp">
              <div class="item-label">Attach Damage Photo</div>
              <div *ngIf="detailFile" class="item-w-100 d-flex align-items-center">
                <app-dp-img-select (fileDelete)="fileDelete(attachFile)"
                                   [deletable]="true"
                                   [initInfo]="attachPreviewInitInfo"
                                   [photoInfo]="{ file: attachFile }"
                                   [previewImageUrl]="getPreviewUrl(attachFile)">
                </app-dp-img-select>
              </div>
            </ng-container>
            <ng-template #isDetailTemp>
              <div class="item-label">Attach Damage Photo</div>
              <div *ngIf="attachFile" class="item-w-100 d-flex align-items-center">
                <app-dp-img-select (showFile)="selectFile(false, attachFile)"
                                   [initInfo]="attachPreviewInitInfo"
                                   [photoInfo]="{ file: attachFile }"
                                   [previewImageUrl]="getPreviewUrl(attachFile)">
                </app-dp-img-select>
              </div>
              <div *ngIf="!attachFile" class="item-value d-flex">
                <div (click)="imgFileInput.click()" class="item-receipts btn-cursor">
                  <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
                  <input #imgFileInput (change)="fileSelected($event)" hidden type="file"/>
                  <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </ng-container>
      <div *ngIf="basic?.showFileUpload && !isDetail" class="item-row mb-16px">
        <div class="item-label">Attach Damage Photo</div>
        <div class="item-value d-flex">
          <div (click)="imgFileInput.click()" class="item-receipts btn-cursor">
            <input [value]="filename" disabled hidden name="filename" placeholder="Select a File">
            <input #imgFileInput (change)="fileSelected($event)" hidden type="file"/>
            <font-awesome [icon]="'fa-light fa-image'" role="button"></font-awesome>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isDetail && !isDraftTicket" class="item-row mb-8px">
      <div class="item-label">Status</div>
      <div *ngIf="isDetail" class="item-w-100">
        <ng-select (change)="statusChange($event.code)"
                   [clearable]="false"
                   [disabled]="!isTicketEditable"
                   [items]="statusList"
                   [ngClass]="{'disable-admin-viewer': isAdminViewerRole}"
                   bindLabel="name"
                   bindValue="code"
                   class="form-control"
                   formControlName="status"
                   placeholder="Select">
          <ng-template let-item="item" ng-label-tmp>
            <dp-status-badge [status]="item.code"></dp-status-badge>
            <span class="select-temp-text ">{{ item.name }}</span>
          </ng-template>
          <ng-template let-index="index" let-item="item" ng-option-tmp>
            <dp-status-badge [status]="item.code"></dp-status-badge>
            <span class="select-temp-text text-truncate">{{ item.name }}</span>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div *ngIf="isDetail && !isDraftTicket" class="item-row mb-8px">
      <div class="item-label">Reason</div>
      <div *ngIf="isDetail" class="item-w-100">
        <ng-select (change)="reasonChange($event.code)"
                   [clearable]="false"
                   [dropdownPosition]="'bottom'"
                   [items]="reasonList"
                   [ngClass]="{'disable-admin-viewer': isAdminViewerRole}"
                   bindLabel="name"
                   bindValue="code"
                   class="form-control"
                   formControlName="reason"
                   placeholder="Select">
          <ng-template let-item="item" ng-label-tmp>
            <dp-badge [color]="color.status" [size]="'wd-fit'" [text]="item.code"></dp-badge>
            <span class="select-temp-text">{{ item.name }}</span>
          </ng-template>
          <ng-template let-index="index" let-item="item" ng-option-tmp>
            <dp-badge [color]="color.status" [size]="'wd-fit'" [text]="item.code"></dp-badge>
            <span class="select-temp-text text-truncate">{{ item.name }}</span>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div *ngIf="isDetail" class="item-row mb-8px">
      <div class="item-label">Posting Date</div>
      <div class="item-value">{{ basic?.postingDate | hqDateOptionalTime }}</div>
      <div class="item-label">Last Update</div>
      <div class="item-value">{{ basic?.lastUpdateDate | hqDateOptionalTime }}</div>
    </div>

    <div *ngIf="isDetail" class="item-row mb-8px">
      <div class="item-label">Complete Date</div>
      <div class="item-value">{{ basic?.completeDate | hqDateOptionalTime }}</div>
    </div>

    <div class="ticket-horizontal-line"></div>

    <div class="l2-title">
      Dealer/Store
    </div>
    <div class="item-row mb-8px">
      <div class="item-label">Dealer</div>
      <div class="item-w-100">
        <ng-container *ngIf="!isDetail; else isDetailTemp">
          <ng-select (change)="selectDealer($event.code)"
                     [clearable]="false"
                     [items]="dealerOptions"
                     bindLabel="name"
                     bindValue="code"
                     class="form-control"
                     formControlName="dealer"
                     placeholder="Select">
          </ng-select>
        </ng-container>
        <ng-template #isDetailTemp>
          {{ ticket.ticketInfo?.dealer?.name }}
        </ng-template>
      </div>
    </div>
    <div *ngIf="[companies.Sea, companies.Seca].includes(this.company)"
         class="item-row mb-8px">
      <div class="item-label">Store</div>
      <div class="item-w-100">
        <ng-container *ngIf="!isDetail; else isDetailTempStore">
          <ng-select (change)="selectDealerStore($event)"
                     [clearable]="false"
                     [items]="storeOptions"
                     bindLabel="name"
                     bindValue="code"
                     class="form-control"
                     formControlName="dealerStore"
                     placeholder="Select">
          </ng-select>
        </ng-container>
        <ng-template #isDetailTempStore>
          {{ ticket.ticketInfo?.dealerStore?.name }}
        </ng-template>
      </div>
    </div>
    <div *ngIf="isDetail && [companies.Sea].includes(company)" class="item-row mb-8px">
      <div class="item-label">Created By</div>
      <div class="item-value">{{ basic?.createdBy }}</div>
    </div>

    <div class="ticket-horizontal-line"></div>

  </div>
</form>
